<template>
  <div class="top-winners">
    <div class="block-title">
      <div class="title">Top winners</div>
      <div class="led"></div>
    </div>
    <div class="table">
      <div class="tbody" v-if="topWinnersData.content.length">
        <div
            class="tr"
            v-for="(row, index) in topWinnersData.content"
            :key="row.id"
        >
          <div
              class="td"
              :class="'td-'+topWinnersData.headers[idx]"
              v-for="(item, idx) in topWinnersData.headers"
              :key="idx + '_item_td'"
              v-if="topWinnersData.headers[idx]"
          >
            <template v-if="topWinnersData.headers[idx] === 'number'">
              <div>
                {{ topWinnersData.content.indexOf(row) + 1 }}
              </div>
            </template>
            <template v-if="topWinnersData.headers[idx] === 'image'">
              <div class="bonus" v-if="row['isBonus'] === 'bonus'">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 0L6.79275 2.5325L9.75528 3.45492L7.90072 5.9425L7.93893 9.04508L5 8.05L2.06107 9.04508L2.09928 5.9425L0.244718 3.45492L3.20725 2.5325L5 0Z" fill="white"/>
                </svg>
              </div>
              <img :src="gamesImages[row['name']] ?? './images/no-image.png'" :alt="row['name']" @error="imageUrlAlt">
            </template>
            <template v-if="topWinnersData.headers[idx] === 'name'">
              <div>
                <span class="name">{{ game ? ('Player #'+$moment(row['date']).unix()) : row['name'] }}</span>
                <div class="more">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.50243 7.89772C9.18694 7.37362 9.68998 6.64827 9.94084 5.8236C10.1917 4.99892 10.1778 4.1164 9.90101 3.30005C9.62425 2.4837 9.09857 1.77457 8.39785 1.27234C7.69713 0.770099 6.85661 0.5 5.99441 0.5C5.13222 0.5 4.29169 0.770099 3.59098 1.27234C2.89026 1.77457 2.36458 2.4837 2.08782 3.30005C1.81106 4.1164 1.79712 4.99892 2.04798 5.8236C2.29884 6.64827 2.80188 7.37362 3.4864 7.89772C2.27174 8.42387 1.25747 9.32496 0.592105 10.4691C0.531759 10.5736 0.499993 10.6921 0.5 10.8127C0.500007 10.9334 0.531787 11.0519 0.592144 11.1564C0.652501 11.2609 0.739309 11.3477 0.843841 11.408C0.948372 11.4683 1.06694 11.5 1.18764 11.5H10.8124C10.9331 11.5 11.0516 11.4683 11.1562 11.408C11.2607 11.3477 11.3475 11.2609 11.4079 11.1564C11.4682 11.0519 11.5 10.9334 11.5 10.8127C11.5 10.6921 11.4682 10.5736 11.4079 10.4691C10.7411 9.32421 9.72495 8.42305 8.50845 7.89772H8.50243Z" fill="white" fill-opacity="0.4"/>
                  </svg>
                  <span v-if="!game">Player <span>#{{ $moment(row['date']).unix() }}</span> ·</span>  <span>{{ $moment(row['date']).fromNow() }}</span>
                </div>
              </div>
            </template>
            <template v-if="topWinnersData.headers[idx] === 'bet'">
              <span>{{ (Math.round(row['bet'] * 100) / 100).toFixed(2) }} x bet</span>
            </template>
            <template v-if="topWinnersData.headers[idx] === 'amount'">
              <span>${{ (Math.round(row['amount'] * 100) / 100).toFixed(2) }}</span>
              <span class="mobile">{{ (Math.round(row['bet'] * 100) / 100).toFixed(2) }} x bet</span>
            </template>
            <template v-if="topWinnersData.headers[idx] === 'actions'">
              <a :href="row['replayUrl']" target="_blank">
                <span v-if="game">Replay</span>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.00033 6C7.46989 6 6.96118 6.21071 6.58611 6.58579C6.21104 6.96086 6.00033 7.46957 6.00033 8C6.00033 8.53043 6.21104 9.03914 6.58611 9.41421C6.96118 9.78929 7.46989 10 8.00033 10C8.53076 10 9.03947 9.78929 9.41454 9.41421C9.78961 9.03914 10.0003 8.53043 10.0003 8C10.0003 7.46957 9.78961 6.96086 9.41454 6.58579C9.03947 6.21071 8.53076 6 8.00033 6ZM8.00033 11.3333C7.11627 11.3333 6.26842 10.9821 5.6433 10.357C5.01818 9.7319 4.66699 8.88406 4.66699 8C4.66699 7.11595 5.01818 6.2681 5.6433 5.64298C6.26842 5.01786 7.11627 4.66667 8.00033 4.66667C8.88438 4.66667 9.73223 5.01786 10.3573 5.64298C10.9825 6.2681 11.3337 7.11595 11.3337 8C11.3337 8.88406 10.9825 9.7319 10.3573 10.357C9.73223 10.9821 8.88438 11.3333 8.00033 11.3333ZM8.00033 3C4.66699 3 1.82033 5.07333 0.666992 8C1.82033 10.9267 4.66699 13 8.00033 13C11.3337 13 14.1803 10.9267 15.3337 8C14.1803 5.07333 11.3337 3 8.00033 3Z" fill="white"/>
                </svg>
              </a>
            </template>
          </div>
        </div>
      </div>
      <div class="tbody" v-else>
        <div class="tr" style="justify-content: center;">
          <div class="td" style="width: 100%;">
            No data yet.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'winners-top-block',
  props: {
    gamesImages: {},
    game: null,
  },
  data() {
    return {
      currentTab: 0,
      topWinnersData: {
        headers: [
          "number",
          "image",
          "name",
          "bet",
          "amount",
          "actions",
        ],
        content: [],
      },
    }
  },
  methods: {
    getTopWinners: async function() {
      await this.$request.get('/true-world/winners-top' + (this.game ? '?game=' + this.game : ''), null, response => {
        this.topWinnersData.content = response.splice(0,5);
      }, error => {
        console.log(error)
      })
    },
    imageUrlAlt: (event) => {
      event.target.src = require("./images/no-image.png");
    }
  },
  async mounted() {
    await this.getTopWinners();
  }
}
</script>

<style lang="less">
.top-winners {
  > .block-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 13px;
    gap: 10px;
    > .img > img {
      display: block;
    }
    .title {
      color: #fff;
      font-size: 22px;
      font-weight: 500;
      line-height: 33px;
      flex-grow: 1;
    }
  }
  > .table {
    display: flex;
    border-radius: 15px;
    overflow: hidden;
    width: 100%;

    > .tbody {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 6px;
      > .tr {
        width: 100%;
        display: flex;
        flex-direction: row;
        background: rgba(201, 216, 255, 0.1);
        backdrop-filter: blur(55px);
        border-radius: 16px;
        &:nth-child(1) {
          background: linear-gradient(0deg, rgba(201, 216, 255, 0.1), rgba(201, 216, 255, 0.1)),
          linear-gradient(90deg, rgba(255, 208, 74, 0.2) 0%, rgba(255, 208, 74, 0) 50%);
          > .td.td-number {
            > div {
              background: linear-gradient(180deg, #F5C248 29.17%, #B78410 100%);
            }
          }
        }
        &:nth-child(2) {
          background: linear-gradient(0deg, rgba(201, 216, 255, 0.1), rgba(201, 216, 255, 0.1)),
          linear-gradient(90deg, rgba(183, 225, 243, 0.2) 0%, rgba(183, 225, 243, 0) 50%);
          > .td.td-number {
            > div {
              background: linear-gradient(180deg, #99BFCF 20.83%, #4B7486 100%);
            }
          }
        }
        &:nth-child(3) {
          background: linear-gradient(0deg, rgba(201, 216, 255, 0.1), rgba(201, 216, 255, 0.1)),
          linear-gradient(90deg, rgba(254, 112, 9, 0.2) 0%, rgba(254, 112, 9, 0) 50%);
          > .td.td-number {
            > div {
              background: linear-gradient(180deg, #EA7C3E 37.76%, #9A4313 100%);
            }
          }
        }
        > .td {
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgba(255, 255, 255, 1);
          height: 66px;
          font-size: 15px;
          font-weight: 500;
          line-height: 23px;
          text-align: left;
          padding: 7px 7px;
          &.td-image {
            position: relative;
            img {
              display: block;
              width: 52px;
              height: 52px;
              border-radius: 10px;
            }
            .bonus {
              position: absolute;
              right: 5px;
              top: 5px;
              width: 16px;
              height: 16px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: linear-gradient(90deg, #9D5BFF 0%, #563AE7 100%);
              border-radius: 100%;
            }
          }
          &.td-number {
            padding-left: 12px;
            div {
              text-align: center;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 100%;
              background: rgba(201, 216, 255, 0.12);
              font-size: 14px;
              font-weight: 600;
              line-height: 32px;
            }
          }
          &.td-name {
            justify-content: flex-start;
            flex-grow: 1;
            div {
              display: flex;
              flex-direction: column;
              justify-content: center;
              gap: 3px;

              .name {
                font-size: 15px;
                font-weight: 500;
                line-height: 23px;
              }

              .more {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                gap: 5px;
                font-size: 11px;
                font-weight: 400;
                line-height: 12px;
                color: #FFFFFF99;
              }
            }
          }
          &.td-bet {
            font-size: 13px;
            font-weight: 500;
            line-height: 20px;
            color: rgba(255, 255, 255, 0.6);
            padding-right: 25px;
          }
          &.td-amount {
            font-size: 15px;
            font-weight: 700;
            line-height: 23px;
            width: 100px;
            justify-content: flex-end;
          }
          &.td-actions {
            width: 70px;
            padding-left: 20px;
            padding-right: 18px;

            a {
              display: flex;
              width: 32px;
              height: 32px;
              background: rgba(201, 216, 255, 0.12);
              justify-content: center;
              align-items: center;
              border-radius: 10px;
              &:hover {
                background: rgba(201, 216, 255, 0.22);
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1439px) {
  .top-winners {
    width: 100%;
    height: auto;
    margin-bottom: 0;
    > .block-title {
      margin-bottom: 18px;
      > .img {
        > img {
          width: 36px;
          height: 36px;
        }
      }
      > .title {
        font-size: 24px;
        line-height: 36px;
      }
    }
    > .table {
      > .tbody {
        > .tr {
          > .td {
            &.td-name {
              justify-content: flex-start;
              flex-grow: 1;
              div {
                display: flex;
                flex-direction: column;
                justify-content: center;
                gap: 3px;

                .name {
                  font-size: 13px;
                  font-weight: 500;
                  line-height: 23px;
                }

                .more {
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: center;
                  gap: 5px;
                  font-size: 11px;
                  font-weight: 400;
                  line-height: 12px;
                  color: #FFFFFF99;
                }
              }
            }
            &.td-image {
              > .bonus {
                top: 5px;
                right: 5px;
              }
            }
            &.td-bet {
              display: none;
            }
            &.td-amount {
              min-width: 58px;
              flex-direction: column;
              justify-content: center;
              align-items: flex-end;
              padding-left: 0;
              padding-right: 0;
              width: 84px;
              > span:first-child {
                font-size: 11px;
                line-height: 16.5px;
              }
              >span.mobile {
                display: block;
                color: #FFFFFF99;
                font-size: 10px;
                font-weight: 500;
                line-height: 15px;
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1023px) {
  .top-winners {
    margin-bottom: 0;
    > .block-title {
      margin-bottom: 12px;
      > .img {
        > img {
          width: 36px;
          height: 36px;
        }
      }
      > .title {
        font-size: 20px;
        line-height: 30px;
      }
    }
    > .table {
      > .tbody {
        > .tr {
          border-radius: 16px;
          > .td {
            height: 66px;
            &.td-image {
              padding-right: 1px;
              > img {
                width: 52px;
                height: 52px;
                border-radius: 9.21px;
              }
              > .bonus {
                right: -2px;
              }
            }
            &.td-name {
              > div {
                > span.name {
                  font-size: 13px;
                  line-height: 21px;
                }
                > div.more {
                  line-height: 11px;
                }
              }
            }
            &.td-rtp {
              width: 90px;
              padding-right: 22px;
              > span {
                &:first-child {
                  font-size: 12px;
                  line-height: 18px;
                }
                &:last-child {
                  font-size: 14px;
                  line-height: 21px;
                }
              }
            }
            &.td-bet {
              display: none;
            }
            &.td-amount {
              min-width: 58px;
              flex-direction: column;
              justify-content: center;
              align-items: flex-end;
              padding-left: 0;
              padding-right: 0;
              > span:first-child {
                font-size: 14px;
                line-height: 16.5px;
              }
              >span.mobile {
                display: block;
                color: #FFFFFF99;
                font-size: 11px;
                font-weight: 500;
                line-height: 15px;
              }
            }
            &.td-status {
              padding-right: 20px;
              > div.status {
                gap: 8px;
                > .percent-25, > .percent-50, > .percent-100 {
                  width: 8px;
                  height: 34px;
                  &:before {
                    width: 8px;
                  }
                }
                > .percent-25:before {
                  height: 10px;
                }
                > .percent-50:before {
                  height: 18px;
                }
                > img {
                  width: 24px;
                  height: 24px;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .top-winners {
    margin-bottom: 10px;
    > .block-title {
      margin-bottom: 10px;
      flex-wrap: wrap;
      > .img {
        > img {
          width: 28px;
          height: 28px;
        }
      }
      > .title {
        font-size: 18px;
        line-height: 27px;
      }
    }
    > .table {
      > .tbody {
        > .tr {
          border-radius: 12px;
          > .td {
            height: 50px;
            &.td-number {
              padding-left: 10px;
              padding-right: 6px;
              > div {
                width: 20px;
                height: 20px;
                font-size: 10px;
                line-height: 15px;
              }
            }
            &.td-image {
              padding-left: 0;
              padding-right: 1px;
              > .bonus {
                top: 5px;
                right: -2px;
                width: 12px;
                height: 12px;
                > svg {
                  width: 7.5px;
                  height: 7.5px;
                }
              }
              > img {
                width: 36px;
                height: 36px;
                border-radius: 6px;
              }
            }
            &.td-name {
              padding-right: 0;
              > div {
                gap: 0;
                > span.name {
                  font-size: 11px;
                  line-height: 16.5px;
                  text-wrap: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  max-width: 86px;
                }
                > div.more {
                  font-size: 10px;
                  line-height: 13px;
                  flex-direction: column;
                  align-items: flex-start;
                  gap: 0;
                  > span {
                    display: flex;
                    justify-content: center;
                    gap: 2px;
                    > span {
                      display: inline-block;
                      text-wrap: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      max-width: 40px;
                    }
                  }
                  > svg {
                    display: none;
                  }
                }
              }
            }
            &.td-bet {
              display: none;
            }
            &.td-amount {
              min-width: 58px;
              flex-direction: column;
              justify-content: center;
              align-items: flex-end;
              padding-left: 0;
              padding-right: 0;
              > span:first-child {
                font-size: 11px;
                line-height: 16.5px;
              }
              >span.mobile {
                display: block;
                color: #FFFFFF99;
                font-size: 10px;
                font-weight: 500;
                line-height: 15px;
              }
            }
            &.td-actions {
              padding-left: 10px;
              padding-right: 10px;
              > a {
                width: 24px;
                height: 24px;
                border-radius: 6px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
